import React, { useEffect, useState } from 'react';
import AdminLayout from './components/adminlayout';
import DashboardCards from './components/dashboardcards';
import { serverURL } from '../constants';
import axios from 'axios';

const Dashboard = () => {
    const [data, setData] = useState({});

    useEffect(() => {
        sessionStorage.setItem('darkMode', false);
        async function dashboardData() {
            const postURL = serverURL + `/api/dashboard`;
            const response = await axios.post(postURL);
            setData(response.data);
            sessionStorage.setItem('terms', response.data.admin.terms);
            sessionStorage.setItem('privacy', response.data.admin.privacy);
            sessionStorage.setItem('cancel', response.data.admin.cancel);
            sessionStorage.setItem('refund', response.data.admin.refund);
            sessionStorage.setItem('billing', response.data.admin.billing);
        }
        dashboardData();
    }, []);

    return (
        <AdminLayout>
            <DashboardCards datas={data} />
        </AdminLayout>
    );
};
export default Dashboard;
